import { useCallback, useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import { Alert, AlertTitle, Stack, TextField, Typography } from '@mui/material'

import { Section } from 'components/controls/section'
import { validationMessages } from 'constants/validation'

import { ValidateFormData } from 'interface/user/register'
import { TenantResult } from 'interface/tenant'
import { CareNet, SystemName } from 'constants/captions'

const {
  Required,
  TooShortLength,
} = validationMessages

const formSchema = yup.object().shape({
  passCode: yup.string()
    .required(Required)
    .min(8, TooShortLength(8)),
})
type FormType = yup.InferType<typeof formSchema>

export const useValidateForm = (
  tenant: TenantResult | undefined,
  domain: string,
  inviteId: string
) => {
  const [isValidated, setIsValidated] = useState(false)
  const form = useForm({
    defaultValues: {
      passCode: ''
    },
    mode: 'onChange',
    criteriaMode: 'all',
    resolver: yupResolver(formSchema)
  })
  const submit = useCallback(
		(input: FormType): ValidateFormData => ({
      passCode: input.passCode
    }),
    []
  )
  return {
    tenant,
    domain,
    inviteId,
    isValidated, setIsValidated,
    form,
    submit
  }
}

export const InviteValidateForm = ({
  tenant,
  form: {
    control,
    formState: { errors },
  }
}: ReturnType<typeof useValidateForm>) => (
  <Stack direction="column" spacing={2}>
    {tenant && (
      <Alert severity="info">
        <AlertTitle>{CareNet} {SystemName}にようこそ</AlertTitle>
        <Typography component="pre" variant='body2'>
          テナント「{tenant.tenantName}」へのユーザー登録を行います<br/>
          メールに記載されている認証コードを入力して下さい
        </Typography>
      </Alert>
    )}

    <Section label="認証コード" labelProps={{ paddingY: 2 }}>
      <Controller
        control={control}
        name="passCode"
        render={({ field }) => (
          <TextField
            {...field}
            variant="outlined"
            placeholder="認証コード"
            autoComplete="new-passCode"
            size="small"
            error={!!errors.passCode}
            helperText={errors.passCode ? errors.passCode.message : ''}
          />
        )}
      />
    </Section>
  </Stack>
)
